import { render, staticRenderFns } from "./ChannelManagerConfig.vue?vue&type=template&id=28044b6a&"
import script from "./ChannelManagerConfig.vue?vue&type=script&lang=js&"
export * from "./ChannelManagerConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28044b6a')) {
      api.createRecord('28044b6a', component.options)
    } else {
      api.reload('28044b6a', component.options)
    }
    module.hot.accept("./ChannelManagerConfig.vue?vue&type=template&id=28044b6a&", function () {
      api.rerender('28044b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/ChannelManagerConfig.vue"
export default component.exports